import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  TextField,
  Theme,
} from '@material-ui/core';

import React, { FC, useState } from 'react';
import { supplierActionRegister } from '../services/generated/ApiClientGenerated';
import { updateSupplierRecoveryAction } from './supplierRecoverySlice';
import { useDispatch } from 'react-redux';

type CommentProps = {
  open: boolean;
  onClose: () => void;
    row: supplierActionRegister;
  title: string;
  confirmationButtonText: string;
  content?: string;
  placeholder?: string;
};

export const SupplierRecoveryCommentDialog: FC<CommentProps> = ({
  open,
  row,
  onClose,
  title,
  confirmationButtonText,
  content,
  placeholder,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
    const [comment, setComment] = useState<string | undefined>(row.comments);

  const maxNoteCharacterLength = 300;

  const clearCount = () => {
    onClose();
    setTimeout(function () {
        setComment(row.comments || '');
    }, 500);
  };

    //updateSupplierRecoveryAction(
    //    baseSupplierId: row.baseSupplierId!,
    //    partNumber: row.partNumber!,
    //    body: {
    //    ...row,
    //    comments: comments,
    //},
    //),

    const handleSubmit = () => {
        if (!row.baseSupplierId) {
            return;
        }
        dispatch(
            updateSupplierRecoveryAction({
                baseSupplierId: row.supplierId!,
                partNumber: row.partNumber!,
                body: {
                    ...row,
                    comments: comment
                },
            }),
        );

        onClose();
    };


  return (
    <Dialog
      className={classes.root}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="comment-dialog-title"
      aria-describedby="comment-dialog-description"
    >
      <DialogTitle className={classes.dialogTitle} id="comment-dialog-title">
        {title}
      </DialogTitle>

      <DialogContent className={classes.content}>
        <TextField
          className={classes.root}
                  error={comment?.length && maxNoteCharacterLength <= comment?.length ? true : false}
          autoFocus
          helperText={
              comment?.length && maxNoteCharacterLength <= comment?.length
              ? 'You have reached the maximum character limit'
                  : `${comment?.length}/${maxNoteCharacterLength}`
          }
          inputProps={{ maxLength: 300 }}
          multiline
          variant="outlined"
          margin="dense"
          id={title.toString()}
          defaultValue={content}
          placeholder={placeholder}
          type="text"
          fullWidth
                  onChange={(e) => {
            if (e.target.value == '') {
                setComment(undefined);
            } else setComment(e.target.value);
          }}
        />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={clearCount} color="default" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" autoFocus>
          {confirmationButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiFormHelperText-root': {
        textAlign: 'right',
        marginRight: theme.spacing(0),
      },
    },
    actions: {
      padding: theme.spacing(0, 3, 2),
    },
    content: {
      padding: theme.spacing(0, 3, 1),
    },
    dialogTitle: {
      padding: theme.spacing(2, 3, 0),
    },

    header: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
    },
  }),
);
